module.exports = __webpack_public_path__ + "static/educationServices-f25f8967cc6f1b4de13663c57c96f1c4.svg";